import api from './api';

const bankService = {
  getAllAccounts: async () => {
    const response = await api.get('/banks');
    return response.data;
  },
  getAccountById: async (id) => {
    const response = await api.get(`/banks/${id}`);
    return response.data;
  },
  createAccount: async (data) => {
    const response = await api.post('/banks', data);
    return response.data;
  },
  deleteAccount: async (id) => {
    const response = await api.delete(`/banks/${id}`);
    return response.data;
  },
  createTransaction: async (data) => {
    const response = await api.post('/banks/transactions', data);
    return response.data;
  },
  getTransactionsByAccountId: async (accountId) => {
    const response = await api.get(`/banks/transactions/${accountId}`);
    return response.data;
  },
  deleteTransaction: async (id) => {
    const response = await api.delete(`/banks/transactions/${id}`);
    return response.data;
  }
};

export default bankService;